import GraphicStorageFields from "./fields";
import GraphicStorageConst from "./graphic-storage-const";
import GraphicStorageHelpers from "./helpers";


const GraphicStorage = {
  Fields: GraphicStorageFields,
  Const: GraphicStorageConst,
  Helpers: GraphicStorageHelpers,
}

export default GraphicStorage;
